import { FilterKeys } from '@common/enums/query-params/filters';
import SphereNavigationRoutes from '@common/enums/query-params/sphere-navigation-routes';

const openRobotPage = (robotId: string) => {
  const url = new URL(SphereNavigationRoutes.Dashboard, window.location.origin);
  url.searchParams.set(FilterKeys.RobotId, robotId);
  window.open(url.toString(), '_blank', 'noopener');
};

export default openRobotPage;
